import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {useParams} from 'react-router-dom'
import {message} from 'antd'
import SupplierForm from "../../components/suppliers/SupplierForm";
import LayoutComponent from "../../components/shared/layout/Layout";
import {
    createNewSupplierAction,
    getSupplierDetailsAction,
    updateSupplierDetailsAction,
    updateSupplierStateValues,
    resetSupplierInputsValues,
} from "../../store/actions/suppliers.action";
import {useHistory} from "react-router-dom";
import {searchPermissionsListAction} from "../../store/actions/permissions.action";
import {searchRolesListAction} from "../../store/actions/roles.action";
import {searchGroupsListAction} from "../../store/actions/groups.action";
import ActionButtonsComponent from "../../components/shared/action-buttons/ActionButtons.component";

const CreateSupplierPage = ({success, error, updateSupplierStateValues,resetSupplierInputsValues, id, loading, getSupplierDetailsAction, selectedSupplierInputs, selectedSupplier, searchPermissionsListAction, searchRolesListAction, searchGroupsListAction,  updateSupplierDetailsAction, createNewSupplierAction}) => {
    const [viewMode, setViewMode] = useState(true)
    const [isNew, setIsNew] = useState(false)
    const idParam = useParams().id

    const navigate = useHistory();

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (success) {
            message.success(success);
            updateSupplierStateValues({
                success: ''
            });
            if (isNew) {
                navigate.push(`/suppliers`);
            } else {
                setViewMode(true);
            }
        }
    }, [navigate, id, isNew, success, updateSupplierStateValues]);

    useEffect(() => {
        resetSupplierInputsValues(idParam);
        if (idParam !== 'new') {
            getSupplierDetailsAction(idParam)
            setIsNew(false)
            setViewMode(true)
        } else {
            setViewMode(false)
            setIsNew(true)
        }
    }, [getSupplierDetailsAction, idParam, resetSupplierInputsValues]);

    useEffect(() => {
        searchPermissionsListAction();
    }, [searchPermissionsListAction]);

    useEffect(() => {
        searchRolesListAction();
    }, [searchRolesListAction]);

    useEffect(() => {
        searchGroupsListAction();
    }, [searchGroupsListAction]);

    useEffect(() => {
        if (error) {
            message.error(error);
            updateSupplierStateValues({
                error: null,
            })
            setViewMode(false)
        }
    }, [error, updateSupplierStateValues]);

    const onChangeInput = (e) => {
        const { name, value } = e.target

        updateSupplierStateValues({
            selectedSupplierInputs: {
                ...selectedSupplierInputs,
                [name]: value,
            }
        });
    }
    // TODO Need to figure out why the method are not the correct redux state values
    const onCancel = () => {
        resetSupplierInputsValues(isNew);
        setViewMode(true);
    };

    const onSave = () => {
        if (!isNew) {
            updateSupplierDetailsAction(selectedSupplierInputs);
        } else {
            createNewSupplierAction(selectedSupplierInputs);
        }
    }

    const onEdit = () => {
        console.log({selectedSupplier, selectedSupplierInputs, id, isNew})
        setViewMode(false);
    };
    return (
        <LayoutComponent loading={loading} actionButtons={[]}>
            <SupplierForm
                viewMode={viewMode}
                isNew={isNew}
                id={idParam}
                onChangeInput={onChangeInput}
            />
            <ActionButtonsComponent
                className='gap-8 right'
                labelMap={{
                    save: 'Save',
                    edit: 'Edit',
                    cancel: 'Cancel'
                }}
                handleSave={onSave}
                handleCancel={onCancel}
                handleEdit={onEdit}
                viewMode={viewMode}
                isNew={isNew}
            />
        </LayoutComponent>
    )
}

CreateSupplierPage.propTypes = {
    loading: PropTypes.bool,
    success: PropTypes.string,
    id: PropTypes.number,
    error: PropTypes.string,
}

const mapStateToProps = ({ suppliersState }) => {
    const selectedSupplierInputs = suppliersState.selectedSupplierInputs;
    const selectedSupplier = {...suppliersState.selectedSupplier};
    return {
        loading: suppliersState.loading,
        success: suppliersState.success,
        id: suppliersState.id,
        error: suppliersState.error,
        selectedSupplierInputs,
        selectedSupplier: Object.keys(selectedSupplier).length ? selectedSupplier : {firstName: 'initial'},
    }
}

export default
connect(mapStateToProps, {
    updateSupplierStateValues,
    getSupplierDetailsAction,
    searchPermissionsListAction,
    searchRolesListAction,
    searchGroupsListAction,
    updateSupplierDetailsAction,
    createNewSupplierAction,
    resetSupplierInputsValues,
})(CreateSupplierPage)
